import Vue from 'vue'
import Vuex from 'vuex'

import analytics from './modules/analytics.store'
import bookings from './modules/bookings.store'
import fixed_bookings from './modules/fixed_bookings.store'
import cancellations from './modules/cancellations.store'
import centers from './modules/centers.store'
import centerAdmin from './modules/center-admin.store'
import checkout from './modules/checkout.store'
import closures from './modules/closures.store'
import configurations from './modules/configurations.store'
import customers from './modules/customers.store'
import fields from './modules/fields.store'
import features from './modules/features.store'
import matches from './modules/matches.store'
import customerSkills from './modules/customer-skills.store'
import pages from './modules/pages.store'
import permissions from './modules/permissions.store'
import promoCodes from './modules/promo-codes.store'
import promotions from './modules/promotions.store'
import promoSAGlobal from './modules/promo-sa-global.store'
import pushAdmin from './modules/push-admin.store'
import pushNotifications from './modules/push_notifications.store'
import reviews from './modules/reviews.store'
import services from './modules/services.store'
import settings from './modules/settings.store'
import sports from './modules/sports.store'
import sportMasterConfig from './modules/sport-master-config.store'
import stats from './modules/stats.store'
import transactions from './modules/transactions.store'
import user from './modules/user.store'
import blacklists from './modules/blacklists.store'
import cancellationReason from './modules/cancellation-reason.store'
import matchStats from './modules/match-stats.store'
import chatbot from './modules/chatbot.store'

Vue.use(Vuex)

export default new Vuex.Store({
    // state: {},
    // mutations: {},
    // actions: {},
    modules: {
        fixed_bookings,
        bookings,
        cancellations,
        centers,
        centerAdmin,
        checkout,
        closures,
        configurations,
        customers,
        customerSkills,
        features,
        fields,
        matches,
        pages,
        permissions,
        promoCodes,
        promotions,
        promoSAGlobal,
        pushAdmin,
        pushNotifications,
        reviews,
        services,
        settings,
        sports,
        sportMasterConfig,
        stats,
        transactions,
        user,
        blacklists,
        cancellationReason,
        matchStats,
        analytics,
        chatbot
    }
})
